import initialState from '../store/initialState'
import templatesTypes from '../constants/templatesTypes'

// const { toast } = window.M

export default function templatesReducer(state = initialState.templates, action) {
  switch (action.type) {

    case templatesTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case templatesTypes.reset_template: {
      return {
        ...initialState.templates,
        items: state.items,
        template: state.template,
        pagination: state.pagination,
        totals: state.totals,
        filters: state.filters,
        sort: state.sort,
        order: state.order
      }
    }

    case "SET_PATH":
    case templatesTypes.clear_template: {
      if (action.type === "SET_PATH" && action.payload !== 'newtemplate') {
        return {
          ...state
        }
      }
      return {
        ...initialState.templates,
        template: {
          answers: []
        },
        items: state.items,
        totals: state.totals,
        pagination: state.pagination,
        filters: state.filters,
        sort: state.sort,
        order: state.order
      }
    }

    // GET
    case templatesTypes.get.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case templatesTypes.get.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        template: action.payload,
        errors: []
      }
    }

    case templatesTypes.get.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // UPDATE
    // case templatesTypes.duplicate.request:
    case templatesTypes.update.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    // case templatesTypes.duplicate.request:
    case templatesTypes.update.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        errors: [],
        template: action.payload
      }
    }

    // case templatesTypes.duplicate.request:
    case templatesTypes.update.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    // INDEX
    case templatesTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case templatesTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        // console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.templates,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        serial: action.payload.serial || 0,
        errors: []
      }
    }

    case templatesTypes.index.select: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        select_items: action.payload.templates,
        errors: []
      }
    }

    case templatesTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    // publish template
    case templatesTypes.publish.request:{
      return {
        ...state,
        setting_status: true,
        set_status: false
      };
    }

    // publish template
    case templatesTypes.publish.success:{
      return {
        ...state,
        setting_status: false,
        set_status: true,
        items: action.payload.templates,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      };
    }

    case templatesTypes.publish.single:{
      const {active, trash, versions, publisher} = action.payload.template
      return {
        ...state,
        setting_status: false,
        set_status: true,
        template: {
          ...state.template,
          active: active,
          trash: trash,
          versions: versions,
          publisher: publisher
        }
      };
    }


    case templatesTypes.publish.failure:{
      return {
        ...state,
        setting_status: false,
        set_status: false,
        errors: action.payload
      }
    }

    // DELETE
    case templatesTypes.destroy.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case templatesTypes.destroy.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        items: action.payload.templates,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      }
    }

    case templatesTypes.destroy.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // CREATE
    // case templatesTypes.create.init: {
    //   return {
    //     ...state,
    //     fetching: false,
    //     fetched: false,
    //     must_redirect: false,
    //     errors: []
    //   }
    // }

    case templatesTypes.create.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        must_redirect: false,
        errors: []
      }
    }

    case templatesTypes.create.success: {
      // toast({
      //   html: "User created successfully"
      // })
      return {
        ...state,
        fetching: false,
        fetched: true,
        must_redirect: true,
        template: action.payload,
        errors: []
      }
    }

    case templatesTypes.create.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    case templatesTypes.xlsx.request: {
      return {
        ...state,
        fetching_xlsx: true,
        errors: []
      }
    }

    case templatesTypes.xlsx.success: {
      return {
        ...state,
        fetching_xlsx: false,
        errors: []
      }
    }

    case templatesTypes.xlsx.failure: {
      return {
        ...state,
        fetching_xlsx: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/templatesReducer.js